import React from 'react';

import Avatar from 'Shared/components/Avatar/Avatar';
import { AvatarType } from 'Shared/constants/types';
import WpModalHeader from 'Wpds/components/modal/WpModalHeader';

import './ModalHeaderWithAvatar.scss';

type Props = {
  title: string;
  description: string;
  avatar?: AvatarType;
  avatarClassName?: string;
  children?: React.ReactNode;
  onToggle?(): void;
};

function ModalHeaderWithAvatar({ onToggle, title, description, avatar, children, avatarClassName = '' }: Props) {
  return (
    <WpModalHeader onToggle={onToggle}>
      <div className="ModalHeaderWithAvatar d-flex pt-2">
        {avatar && (
          <div className="mr-3">
            <Avatar avatar={avatar} height={84} classNames={`align-self-center ${avatarClassName}`} />
          </div>
        )}
        <div className="d-flex flex-column">
          <div className="ModalHeaderWithAvatar__title">{title}</div>
          <div className="ModalHeaderWithAvatar__description text-muted">{description}</div>
        </div>
      </div>
      {children}
    </WpModalHeader>
  );
}

export default ModalHeaderWithAvatar;
